// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__1KkOY","content":"styles_content__3c6OU","intro":"styles_intro__31dYC"};